<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
    
    <mat-spinner [diameter]="250"></mat-spinner>
    
    <!--
      <table style="text-align: center; border: 3px;">
        <tr>
          <td>
            <img src="assets/images/logo_cns_branco.png">
            
          </td>
        </tr>
        <tr>
          <td>
            <span class="loading-message"><b>Carregando... por favor, aguarde.</b></span>
            
          </td>
        </tr>
      </table>
    -->

    
  </div>
</div>